import { render, staticRenderFns } from "./Indicator.vue?vue&type=template&id=0c6811f2&scoped=true&"
import script from "./Indicator.vue?vue&type=script&lang=js&"
export * from "./Indicator.vue?vue&type=script&lang=js&"
import style0 from "./Indicator.vue?vue&type=style&index=0&id=0c6811f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6811f2",
  null
  
)

export default component.exports